import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/";
import partnerService from "@/services/partnerService";
import Energy from "@/views/Energy";
import Consumption from "@/views/Consumption";
import Calculation from "@/views/Calculation";
import Contact from "@/views/Contact";
import Process from "@/views/Process";
import Simulation from "@/views/Simulation";
import Comparison from "@/views/Comparison";
import ServerError from "@/views/ServerError";
import partnerHelpers from "@/helpers/partnerHelpers";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.URL_BASE,
  routes: [
    {
      path: "/energy",
      name: "Energy",
      component: Energy
    },
    {
      path: "/calculation",
      name: "Calculation",
      component: Calculation,
      beforeEnter(to, from, next) {
        if (store.state.energy.valid) {
          next();
        } else {
          next("/energy");
        }
      }
    },
    {
      path: "/consumption",
      name: "Consumption",
      component: Consumption,
      beforeEnter(to, from, next) {
        if (store.state.energy.valid && store.state.calculation.valid) {
          next();
        } else {
          next("/calculation");
        }
      }
    },
    {
      path: "/contact",
      name: "Contact",
      component: Contact,
      beforeEnter(to, from, next) {
        if(store.state.common.customerRef != undefined && store.state.common.customerRef != null) {
          next("/process");
        } else if (
          store.state.energy.valid &&
          store.state.consumption.valid &&
          store.state.calculation.valid
        ) {
          next();
        } else {
          next("/consumption");
        }
      }
    },
    {
      path: "/process",
      name: "Process",
      component: Process,
      beforeEnter(to, from, next) {
        if (
          store.state.energy.valid &&
          store.state.consumption.valid &&
          store.state.calculation.valid
        ) {
          next();
        } else {
          next("/calculation");
        }
      }
    },
    {
      path: "/simulation",
      name: "Simulation",
      component: Simulation,
      beforeEnter(to, from, next) {
        if (store.state.calculation.valid) {
          next();
        } else {
          next("/calculation");
        }
      }
    },
    {
      path: "/comparison",
      name: "Comparison",
      component: Comparison,
      beforeEnter(to, from, next) {
        if (store.state.calculation.valid) {
          next();
        } else {
          next("/calculation");
        }
      }
    },
    {
      path: "/server-error",
      name: "ServerError",
      component: ServerError,
    },
    {
      path: "/",
      redirect: to => {
        let path = { name: 'Energy' };
        if (
          store.state.energy.valid &&
          store.state.consumption.valid &&
          store.state.calculation.valid
        )
          path.name = "Contact";
        else if (store.state.energy.valid && store.state.calculation.valid)
          path.name = "Consumption";
        else if (store.state.energy.valid) path.name = "Calculation";
        else path.name = "Energy";

        return path;
      }
    }
  ]
});

router.beforeEach(async (to, _from, next) => {
  if (to.query.lang) {
    await store.dispatch("middleware/setLanguage", to.query.lang);
  }

  if (to.query.newSession !== undefined) {
    await store.dispatch("middleware/newSession");
    delete to.query.newSession;
    if (Object.keys(to.query).length == 0) {
      next({ name: "Energy", query: to.query });
    }
  } else if (to.query.uuid) {
   // await store.dispatch("middleware/setByUuid", to.query.uuid);
    delete to.query.uuid;
    //next({ name: "Process", query: to.query });
    next({ name: "Energy", query: to.query });
  } else if (to.query.fill !== undefined) { // to fill with parameters
    delete to.query.fill
    await store.dispatch("middleware/newSession");
    await store.dispatch("middleware/setGlobalState", to.query);
    next({ name: "Process", query: to.query });
  } else if (to.query.forced !== undefined) {
    delete to.query.forced
    // await store.dispatch("middleware/newSession");
    await store.dispatch("middleware/setForcedProducts", to.query);
    next({ name: "Process", query: to.query });
  }

  if (to.query.noSubscribe !== undefined) {
    store.commit("common/setNoSubscribe", true, { root: true });
    delete to.query.noSubscribe;
  }

  if (to.query.jwt !== undefined) {
    store.commit("common/setAgentJwt", to.query.jwt, { root: true });
    const arrayToken = to.query.jwt.split('.');
    const tokenPayload = JSON.parse(window.atob(arrayToken[1]));
    delete to.query.jwt;
    const partnerSettings = await partnerHelpers.getPartnerSettings(tokenPayload.agentId); // ER-1212.
    store.commit("common/setAllowBxlResi", partnerSettings.allow_bxl_resi, { root: true });
    next({ name: "Energy", query: to.query });
  }

  if (to.query.agent !== undefined) { // ER-705.
    const partnerSettings = await partnerHelpers.getPartnerSettings(to.query.agent); // ER-1212.
    store.commit("common/setAgentRef", to.query.agent, { root: true });
    store.commit("common/setAllowBxlResi", partnerSettings.allow_bxl_resi, { root: true });
    delete to.query.agent;
    next({ name: "Energy", query: to.query });
  }

  if(to.query.simulation !== undefined && to.query.simulation === "1" || to.query.simulation === "0"){
    store.commit("calculation/setSimulation", !!((parseInt(to.query.simulation))), {root: true});
    delete to.query.simulation;
  }

  if(to.query.isPro !== undefined){
    if (to.query.isPro && !!((parseInt(to.query.isPro))) === false){
      store.commit("contact/setIsPro", false, {root: true});
    }else{
      store.commit("contact/setIsPro", true, {root: true});
    }
    delete to.query.isPro;
  }

  if (to.query.energy !== undefined && !store.state.common.uuid) { // ER-791
    let path = { name: 'Energy', query: to.query };
    store.commit("energy/setType", to.query.energy, {root: true});
    await store.dispatch("common/setUuid");
    if(store.state.common.uuid === undefined){
      next(path);
    }
    store.commit("energy/setValid", 1, {root: true});
    await store.dispatch("common/save");
    await store.dispatch("energy/save");
    delete to.query.energy;
    path.name = 'Calculation';
    if (to.query.zipCode !== undefined && to.query.city !== undefined){
      store.commit("calculation/setZipCode", to.query.zipCode, {root: true});
      await store.dispatch("calculation/getCity");
      store.commit("calculation/setCity", to.query.city, {root: true}); // MUST BE AFTER "calculation/getCity"
      const allowResi = store.getters["common/allowBXResi"];
      const isBxl = store.getters["calculation/isBxl"];

      if (isBxl && !allowResi) {
          store.commit('contact/setIsPro', true, {root: true})
      }

      await store.dispatch("calculation/getProviders");
      store.commit("calculation/setValid", 1, {root: true});
      await store.dispatch("calculation/save");
      path.name = 'Consumption';

      delete to.query.zipCode;
      delete to.query.city;
    }

    next(path);
  }

  if (!to.name) {
    next("/energy");
  } else {
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js